import React from "react";

const renderCentroOptions = (centros = [], loading) => {
  if (loading) {
    return (
      <option value="" disabled>
        Cargando centros...
      </option>
    );
  }
  if (!centros.length) {
    return (
      <option value="" disabled>
        Sin centros disponibles
      </option>
    );
  }
  return centros.map((centro) => (
    <option key={centro.id} value={String(centro.id)}>
      {centro.alias || centro.nombre}
    </option>
  ));
};

export default function CiclosFilters({
  filtros,
  setFiltros,
  limpiarFiltros,
  estadoOptions = [],
  centros = [],
  centrosLoading = false,
  anioOptions = [],
}) {
  return (
    <div className="management-card ciclos-filters-card management-filters-card mb-4">
      <div className="row g-3 align-items-end">
        <div className="col-12 col-md-4">
          <label className="form-label management-label mb-1">Buscar</label>
          <input
            type="search"
            className="form-control"
            placeholder="Codigo, nombre o centro"
            value={filtros.search}
            onChange={(e) => setFiltros((prev) => ({ ...prev, search: e.target.value }))}
          />
        </div>
        <div className="col-6 col-md-2">
          <label className="form-label management-label mb-1">Activo</label>
          <select
            className="form-select"
            value={filtros.activo}
            onChange={(e) => setFiltros((prev) => ({ ...prev, activo: e.target.value }))}
          >
            <option value="all">Todos</option>
            <option value="1">Activos</option>
            <option value="0">Inactivos</option>
          </select>
        </div>
        <div className="col-6 col-md-2">
          <label className="form-label management-label mb-1">Centro</label>
          <select
            className="form-select"
            value={filtros.centro_id}
            onChange={(e) => setFiltros((prev) => ({ ...prev, centro_id: e.target.value }))}
          >
            <option value="all">Todos</option>
            {renderCentroOptions(centros, centrosLoading)}
          </select>
        </div>
        <div className="col-6 col-md-2">
          <label className="form-label management-label mb-1">Año</label>
          <select
            className="form-select"
            value={filtros.anio}
            onChange={(e) => setFiltros((prev) => ({ ...prev, anio: e.target.value }))}
          >
            <option value="all">Todos</option>
            {anioOptions.map((anio) => (
              <option key={anio} value={anio}>
                {anio}
              </option>
            ))}
          </select>
        </div>
        <div className="col-6 col-md-2">
          <label className="form-label management-label mb-1">Estado</label>
          <div className="input-group">
            <select
              className="form-select"
              value={filtros.estado}
              onChange={(e) => setFiltros((prev) => ({ ...prev, estado: e.target.value }))}
            >
              <option value="all">Todos</option>
              {estadoOptions.map((estado) => (
                <option key={estado.value} value={estado.value}>
                  {estado.label}
                </option>
              ))}
            </select>
            <button type="button" className="btn management-btn-primary management-btn-tiny" onClick={limpiarFiltros}>
              <i className="bi bi-eraser-fill me-1" />
              Limpiar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
